module.exports = __webpack_public_path__ + "img/logo-mall-p2.5fa1f941.webp";